import { render, staticRenderFns } from "./QuestionTake.vue?vue&type=template&id=3573fb62&scoped=true&"
import script from "./QuestionTake.vue?vue&type=script&lang=js&"
export * from "./QuestionTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573fb62",
  null
  
)

export default component.exports